import * as React from "react";

export const Companies: any = [];

Companies[0] = {
    CompanyName: "GAIIL",
    CoexistencesMax: 0.4,
    MaxAgeContributionExtracts: 50,
    MaxAgeMilitaryContributionExtracts: 50,
    MaxSickDays: 10,
    MaxRVMSickDays: 30,
    PovertyMin: 500,
    RVMLimit: 80000,
    ContractType: {
        Undetermined: "",
        DeterminedMinor: "La Compagnia Assicurativa non assicura il Cedente con Contratto di lavoro a Tempo Determinato che scade prima della Fine del Piano di Ammortamento",
        DeterminedMajor: "La Compagnia Assicurativa non assicura il Cedente con Contratto di lavoro a Tempo Determinato anche se scade dopo la Fine del Piano di Ammortamento"
    },
    WorkingHoursType: {
        FullTime: "",
        VerticalPartTime: "La Compagnia Assicurativa non assicura il Cedente con Part Time Verticale",
        HorizontalPartTime: ""
    },
    WorkTimePercentage: {
        MinValue: 50,
        Message: "La Compagnia Assicurativa non assicura il Cedente con Contratto di lavoro Part Time con una riduzione dell'Orario di Lavoro maggiore del 50%"
    },
    CurrentEmployment: {
        MaxLength: 45,
        Message: "Il Cedente ha superato il requisito massimo di Anzianità di Servizio fissato ad anni 45"
    },
    InsuranceAmount: {
        MaxValue: 80000,
        Message: "Il Capitale da assicurare non può essere superiore ad 80.000,00 €. In questo caso è necessaria pre-accettazione assicurativa",
        BlockedValue: 100000,
        BlockedValueMessage: "Il Capitale da assicurare non può essere superiore ad 100.000,00 €."
    },
    OtherLoansEnd: {
        MilitaryYears: 3,
        NonMilitaryYears: 3,
        Message:
            "In Relazione agli Impegni in corso ed alle relative scadenze è necessario che il Cedente estingua tali Impegni, altrimenti la richiesta di finanziamento dovrà essere sottoposta alla Preaccettazione"
    },
    EmploymentDate: {
        MinEmploymentMonths: 3,
        Messages: {
            MinEmploymentMonths: "E' prevista un'Anzianità Minima di Servizio non inferiore ai 3 mesi",
            LessThanBirthDay: "La Data di Assunzione non può essere inferiore alla Data di Nascita"
        }
    },
    IsTrialPeriodFinished: {
        TrialPeriod: true,
        Message: "E' necessario che il Cedente abbia superato il Periodo di Prova previsto dal CCNL"
    },
    DateOfBirth: {
        MaxAge: 67,
        Message: "Il Cedente all'Inizio del Piano di Ammortamento ha un'età Anagrafica superione ad anni 67 - RICHIEDERE PREACCETTAZIONE"
    },
    Installment: {
        PensionInstallmentTreshold: 0.8,
        Messages: {
            EmptyInstallment: "La Rata Ceduta non può essere Nulla",
            NoDistraintInstallmentReduction:
                "In Relazione ai Requisiti Pensionistici raggiunti dal Cedente entro i 3 anni dalla data del Finanziamento, la rata non può superare 1/5 dell'80% dello Stipendio Netto Mensile. In questo caso la Rata Ceduta Massima è pari ad ",
            NoDistraintNoInstallmentReduction: "La rata non può superare 1/5 dello Stipendio Netto Mensile. In questo caso la Rata Ceduta Massima è pari ad ",
            DistraintInstallmentReduction:
                "l Cedente raggiunge i Requisiti Pensionistici entro i 3 anni dalla data del Finanziamento. In considerazione dei Pignoramenti presenti (Regola Doppio Quinto) e della riduzione prevista dell'80% la Rata Ceduta Massima è pari ad ",
            DistraintNoInstallmentReduction: "In considerazione dei Pignoramenti presenti (Doppio Quinto), la Rata Ceduta Massima è pari ad ",
            Military: {
                NoDistraintInstallmentReduction:
                    "In Relazione ai Requisiti Pensionistici raggiunti dal Cedente entro i 3 anni dalla data del Finanziamento, la rata non può superare 1/5 dell'80% dello Stipendio Netto Mensile. In questo caso la Rata Ceduta Massima è pari ad ",
                NoDistraintNoInstallmentReduction: "La rata non può superare 1/5 dello Stipendio Netto Mensile. In questo caso la Rata Ceduta Massima è pari ad ",
                DistraintInstallmentReduction:
                    "l Cedente raggiunge i Requisiti Pensionistici entro i 3 anni dalla data del Finanziamento. In considerazione dei Pignoramenti presenti (Regola Doppio Quinto) e della riduzione prevista dell'80% la Rata Ceduta Massima è pari ad ",
                DistraintNoInstallmentReduction: "In considerazione dei Pignoramenti presenti (Doppio Quinto), la Rata Ceduta Massima è pari ad "
            }
        }
    },
    InsuranceAge: {
        MaxValue: 67,
        Message: "All'inizio dell'Ammortamento l'Età del Cedente non può essere superiore ad anni 67"
    },
    FinalInsuranceAge: {
        MaxValue: 75,
        Message: "Alla scadenza dell'Ammortamento l'Età del Cedente non può essere superiore ad anni 75"
    },
    TotalResidualDebt: {
        MaxValue: 80000,
        Message: "Il cumulo del montante e delle coesistenze è maggiore di 80.000,00 € - NECESSARIA PREACCETTAZIONE"
    },
    DebtorIsMilitary: {
        PensionTresholdYears: 3,
        PensionAge: 67,
        CombinedPensionAge: 62,
        PensionMonthsOfWork: 514,
        CombinedPensionMonthsOfWork: 456,
        Military: {
            PensionTresholdYears: 3,
            PensionAge: 60,
            CombinedPensionAge: 57,
            PensionMonthsOfWork: 480,
            CombinedPensionMonthsOfWork: 420
        },
        Message: "Il Cedente raggiunge i Requisiti Pensionistici durante il periodo di copertura del Finanziamento"
    },
    Documentation: {
        Messages: {
            NoContributingExtractsMaxSickDaysNotExceededNoRvm: "",
            ContributingExtractsMaxSickDaysNotExceededNoRvm: "E' richiesta la presentazione degli Estratti Contributivi",
            NoContributingExtractsMaxSickDaysExceededNoRvm: "E' necessaria la dichiarazione dell’Amministrazione di rientro regolare in servizio",
            NoContributingExtractsMaxSickDaysNotExceededRvm:
                "E' necessaria la presentazione del Rapporto di Visita Medica (RVM). In caso di presenza di Invalidità E' NECESSARIO allegare il Verbale di Prima Istanza",
            ContributingExtractsMaxSickDaysExceededNoRvm: "E' richiesta la presentazionme degli Estratti Contributivi e la dichiarazione dell’Amministrazione di rientro regolare in servizio",
            NoContributingExtractsMaxSickDaysExceededRvm:
                "E' necessaria la dichiarazione dell’Amministrazione di rientro regolare in servizio e la presentazione del Rapporto di Visita Medica (RVM). In caso di presenza di Invalidità E' NECESSARIO allegare il Verbale di Prima Istanza.",
            ContributingExtractsMaxSickDaysNotExceededRvm:
                "E' richiesta la presentazione degli Estratti Contributivi e del Rapporto di Visita Medica (RVM). In caso di presenza di Invalidità E' NECESSARIO allegare il Verbale di Prima Istanza.",
            ContributingExtractsMaxSickDaysExceededRvm:
                "E' richiesta la presentazionme degli Estratti Contributivi, della dichiarazione dell’Amministrazione di rientro regolare in servizio e del Rapporto di Visita Medica (RVM). In caso di presenza di Invalidità E' NECESSARIO allegare il Verbale di Prima Istanza."
        }
    }
};

Companies[1] = {
    CompanyName: "SGI",
    CoexistencesMax: 0.5,
    MaxAgeContributionExtracts: 50,
    MaxAgeMilitaryContributionExtracts: 50,
    MaxSickDays: 10,
    MaxRVMSickDays: 30,
    PovertyMin: 500,
    RVMLimit: 100000,
    ContractType: {
        Undetermined: "",
        DeterminedMinor: "La Compagnia Assicurativa non assicura il Cedente con Contratto di lavoro a Tempo Determinato che scade prima della Fine del Piano di Ammortamento",
        DeterminedMajor: ""
    },
    WorkingHoursType: {
        FullTime: "",
        VerticalPartTime: "",
        HorizontalPartTime: ""
    },
    WorkTimePercentage: {
        MinValue: 50,
        Message: "La Compagnia Assicurativa non assicura il Cedente con Contratto di lavoro Part Time con una riduzione dell'Orario di Lavoro maggiore del 50%"
    },
    CurrentEmployment: {
        MaxLength: 40,
        Message: "Il Cedente ha superato il requisito massimo di Anzianità di Servizio fissato ad anni 40"
    },
    InsuranceAmount: {
        MaxValue: 100000,
        Message: "Il Capitale da assicurare non può essere superiore ad 100.000,00 €. In questo caso è necessaria pre-accettazione assicurativa"
    },
    OtherLoansEnd: {
        MilitaryYears: 999,
        NonMilitaryYears: 999,
        Message:
            "In Relazione agli Impegni in corso ed alle relative scadenze è necessario che il Cedente estingua tali Impegni, altrimenti la richiesta di finanziamento dovrà essere sottoposta alla Preaccettazione"
    },
    EmploymentDate: {
        MinEmploymentMonths: 3,
        Messages: {
            MinEmploymentMonths: "E' prevista un'Anzianità Minima di Servizio non inferiore ai 3 mesi",
            LessThanBirthDay: "La Data di Assunzione non può essere inferiore alla Data di Nascita"
        }
    },
    IsTrialPeriodFinished: {
        TrialPeriod: false,
        Message: ""
    },
    DateOfBirth: {
        MaxAge: 67,
        Message: "Il Cedente all'Inizio del Piano di Ammortamento ha un'età Anagrafica superione ad anni 67 - RICHIEDERE PREACCETTAZIONE"
    },
    Installment: {
        PensionInstallmentTreshold: 0.8,
        Messages: {
            EmptyInstallment: "La Rata Ceduta non può essere Nulla",
            NoDistraintInstallmentReduction:
                "In relazione al raggiungimento dell'età di 73 anni durante il Finanziamento, la rata non può superare 1/5 dell'80% dello Stipendio Netto Mensile. In questo caso la Rata Ceduta Massima è pari ad ",
            NoDistraintNoInstallmentReduction: "La rata non può superare 1/5 dello Stipendio Netto Mensile. In questo caso la Rata Ceduta Massima è pari ad ",
            DistraintInstallmentReduction:
                "In relazione al raggiungimento dell'età di 73 anni durante il Finanziamento. In considerazione dei Pignoramenti presenti (Regola Doppio Quinto) e della riduzione prevista dell'80% la Rata Ceduta Massima è pari ad ",
            DistraintNoInstallmentReduction: "In considerazione dei Pignoramenti presenti (Doppio Quinto), la Rata Ceduta Massima è pari ad ",
            Military: {
                NoDistraintInstallmentReduction:
                    "In relazione al raggiungimento dell'età di 73 anni durante il Finanziamento, la rata non può superare 1/5 dell'80% dello Stipendio Netto Mensile. In questo caso la Rata Ceduta Massima è pari ad ",
                NoDistraintNoInstallmentReduction: "La rata non può superare 1/5 dello Stipendio Netto Mensile. In questo caso la Rata Ceduta Massima è pari ad ",
                DistraintInstallmentReduction:
                    "In relazione al raggiungimento dell'età di 73 anni durante il Finanziamento. In considerazione dei Pignoramenti presenti (Regola Doppio Quinto) e della riduzione prevista dell'80% la Rata Ceduta Massima è pari ad ",
                DistraintNoInstallmentReduction: "In considerazione dei Pignoramenti presenti (Doppio Quinto), la Rata Ceduta Massima è pari ad "
            }
        }
    },
    InsuranceAge: {
        MaxValue: 67,
        Message: "All'inizio dell'Ammortamento l'Età del Cedente non può essere superiore ad anni 67"
    },
    FinalInsuranceAge: {
        MaxValue: 75,
        Message: "Alla scadenza dell'Ammortamento l'Età del Cedente non può essere superiore ad anni 75"
    },
    TotalResidualDebt: {
        MaxValue: 100000,
        Message: "Il cumulo del montante e delle coesistenze è maggiore di 100.000,00 € - NECESSARIA PREACCETTAZIONE"
    },
    DebtorIsMilitary: {
        PensionTresholdYears: 999,
        PensionAge: 73,
        CombinedPensionAge: 73,
        PensionMonthsOfWork: 999,
        CombinedPensionMonthsOfWork: 999,
        Military: {
            PensionTresholdYears: 999,
            PensionAge: 73,
            CombinedPensionAge: 73,
            PensionMonthsOfWork: 999,
            CombinedPensionMonthsOfWork: 999
        },
        Message: "Il Cedente raggiunge i Requisiti Pensionistici durante il periodo di copertura del Finanziamento"
    },
    Documentation: {
        Messages: {
            NoContributingExtractsMaxSickDaysNotExceededNoRvm: "",
            ContributingExtractsMaxSickDaysNotExceededNoRvm: "E' richiesta la presentazione degli Estratti Contributivi",
            NoContributingExtractsMaxSickDaysExceededNoRvm: "E' necessaria la dichiarazione dell’Amministrazione di rientro regolare in servizio",
            NoContributingExtractsMaxSickDaysNotExceededRvm:
                "E' necessaria la presentazione del Rapporto di Visita Medica (RVM). In caso di presenza di Invalidità E' NECESSARIO allegare il Verbale di Prima Istanza",
            ContributingExtractsMaxSickDaysExceededNoRvm: "E' richiesta la presentazionme degli Estratti Contributivi e la dichiarazione dell’Amministrazione di rientro regolare in servizio",
            NoContributingExtractsMaxSickDaysExceededRvm:
                "E' necessaria la dichiarazione dell’Amministrazione di rientro regolare in servizio e la presentazione del Rapporto di Visita Medica (RVM). In caso di presenza di Invalidità E' NECESSARIO allegare il Verbale di Prima Istanza.",
            ContributingExtractsMaxSickDaysNotExceededRvm:
                "E' richiesta la presentazione degli Estratti Contributivi e del Rapporto di Visita Medica (RVM). In caso di presenza di Invalidità E' NECESSARIO allegare il Verbale di Prima Istanza.",
            ContributingExtractsMaxSickDaysExceededRvm:
                "E' richiesta la presentazionme degli Estratti Contributivi, della dichiarazione dell’Amministrazione di rientro regolare in servizio e del Rapporto di Visita Medica (RVM). In caso di presenza di Invalidità E' NECESSARIO allegare il Verbale di Prima Istanza."
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/DigitalProductAnalyser/config.ts